import React, { createContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useUsernameRecorder } from "./AnalyticsHook";
import { isAnalyticsEnabled } from "./AnalyticsPageViewRecorderHook";
const AnalyticsContext = /*#__PURE__*/createContext({});
export const AnalyticsContextProvider = ({
  children
}) => {
  const userNameHook = useUsernameRecorder();
  const analyticsContext = useMemo(() => ({
    ...userNameHook
  }), [userNameHook]);
  if (!isAnalyticsEnabled) {
    return children;
  }
  return /*#__PURE__*/React.createElement(AnalyticsContext.Provider, {
    value: analyticsContext
  }, children);
};
AnalyticsContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};